"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACK_PACKAGE_REDUCER = exports.RETURN_ORDER_REDUCER = exports.REORDER = exports.ORDER_DETAILS_REDUCER = exports.NEW_MERGE_CART = exports.MERGE_CART = exports.INSTORE_ORDER_DETAILS = exports.GET_RETURN_STATUS = exports.GET_RETURN_DETAILS = exports.GET_PRESCRIPTION_ORDER_DETAILS = exports.GET_MY_ORDER_JSON = exports.GET_MY_INSTORE_ORDER = exports.DOWNLOAD_INVOICE_REDUCER = exports.CREATE_RETURN_ITEM = exports.CANCEL_ORDER_REDUCER = exports.CANCEL_MERGE_CART = void 0;
const GET_MY_ORDER_JSON = exports.GET_MY_ORDER_JSON = 'getMyOrderJson';
const ORDER_DETAILS_REDUCER = exports.ORDER_DETAILS_REDUCER = 'orderDetailsReducer';
const CANCEL_ORDER_REDUCER = exports.CANCEL_ORDER_REDUCER = 'cancelOrderReducer';
const TRACK_PACKAGE_REDUCER = exports.TRACK_PACKAGE_REDUCER = 'trackProductReducer';
const RETURN_ORDER_REDUCER = exports.RETURN_ORDER_REDUCER = 'returnOrderReducer';
const MERGE_CART = exports.MERGE_CART = 'mergeCart';
const NEW_MERGE_CART = exports.NEW_MERGE_CART = 'newMergeCart';
const CANCEL_MERGE_CART = exports.CANCEL_MERGE_CART = 'cancelMergeCart';
const REORDER = exports.REORDER = 'reorder';
const DOWNLOAD_INVOICE_REDUCER = exports.DOWNLOAD_INVOICE_REDUCER = 'downloadInvoiceReducer';
const GET_MY_INSTORE_ORDER = exports.GET_MY_INSTORE_ORDER = 'getMyInStoreOrder';
const INSTORE_ORDER_DETAILS = exports.INSTORE_ORDER_DETAILS = 'inStoreOrderDetails';
const GET_PRESCRIPTION_ORDER_DETAILS = exports.GET_PRESCRIPTION_ORDER_DETAILS = 'getPrescriptionOrderDetails';
const CREATE_RETURN_ITEM = exports.CREATE_RETURN_ITEM = 'createReturnItem';
const GET_RETURN_STATUS = exports.GET_RETURN_STATUS = 'getReturnStatus';
const GET_RETURN_DETAILS = exports.GET_RETURN_DETAILS = 'getReturnDetails';